import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { getAdminProfile as getAdminProfileAction } from "@/redux/actions/auth";

import { adminProfileKeys } from "../keyFactory";
import { updateAdminProfile } from "../queryFunctions/updateAdminProfile";
import type { UpdateAdminProfileVariables } from "../queryFunctions/updateAdminProfile";

export function useUpdateAdminProfile({
  onSuccess,
  ...options
}: UseMutationOptions<void, unknown, UpdateAdminProfileVariables> = {}) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAdminProfile,
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: adminProfileKeys.details() });
      // keep Redux store in sync for legacy consumers (AdminRouter)
      // TODO: if dispatch fails, onSuccess still fires — callers should not assume Redux is in sync
      dispatch(getAdminProfileAction());
      onSuccess?.(data, variables, context);
    },
  });
}
